module.exports = __webpack_public_path__ + "static/rocket-to-phone-bluebg-6ffabc623ac267fff2ff3e705a210213.gif";